import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchAvailableDays = async (addressData) => {
    try {
        const response = await axios.post(`${API_URL}/api/platinum/available-days`, addressData);
        return response.data;
    } catch (error) {
        console.error('Error fetching available days:', error);
        throw error;
    }
};

export const createPlatinumBooking = async (bookingData) => {
    try {
        // Using the existing cleaning booking endpoint for now
        const response = await axios.post(`${API_URL}/api/cleaning/bookings`, bookingData);
        return response.data;
    } catch (error) {
        console.error('Error creating booking:', error);
        throw error;
    }
};
